// extracted by mini-css-extract-plugin
export var calculatedBadge = "_x7-8";
export var container = "_x7-0";
export var radioDot = "_x7-5";
export var radioDotSelected = "_x7-6";
export var row = "_x7-1";
export var rowFirst = "_x7-2";
export var rowLast = "_x7-3";
export var rowSelected = "_x7-4";
export var strikethrough = "_x7-7";